// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__5sY4O","location":"Header_location__V4LjP"};